<!--
 * @Description: 
 * @Author: wjx 
 * @Date: 2019-05-09 18:39:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2019-11-19 17:50:18
 -->
<template>
  <div class="upload-container">
    <el-button
      :style="{ background: color, borderColor: color }"
      icon="el-icon-upload"
      size="mini"
      type="primary"
      @click="dialogVisible = true"
    >
      上传图片
    </el-button>
    <el-dialog :visible.sync="dialogVisible" :modal="false">
      <el-upload
        :multiple="true"
        :file-list="fileList"
        :show-file-list="true"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :on-error="handleError"
        :before-upload="beforeUpload"
        class="editor-slide-upload"
        :action="uploadImage"
        list-type="picture-card"
        accept="image/*"
      >
        <el-button size="small" type="primary">
          点击或拖拽
        </el-button>
      </el-upload>
      <el-button @click="dialogVisible = false">
        取 消
      </el-button>
      <el-button type="primary" @click="handleSubmit">
        确 定
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
// import { getToken } from 'api/qiniu'
import { uploadImage } from '@/api/ajax';

export default {
  name: 'EditorSlideUpload',
  props: {
    color: {
      type: String,
      default: '#1890ff'
    },
    //限制图片尺寸大小[width，height]
    limitImgSize: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      uploadImage,
      dialogVisible: false,
      listObj: {},
      fileList: []
    };
  },
  methods: {
    checkAllSuccess() {
      return Object.keys(this.listObj).every(
        item => this.listObj[item].hasSuccess
      );
    },
    handleError(err, file, fileList) {
      this.$message(`图片${file.name}上传失败，请您检查网络或压缩图片大小`);
      delete this.listObj[file.uid];
    },
    handleSubmit() {
      const arr = Object.keys(this.listObj).map(v => this.listObj[v]);
      if (!this.checkAllSuccess()) {
        this.$message('请等全部上传成功后，再继续操作。');
        return;
      }
      this.$emit('successCBK', arr);
      this.listObj = {};
      this.fileList = [];
      this.dialogVisible = false;
    },
    handleSuccess(response, file) {
      const uid = file.uid;
      const objKeyArr = Object.keys(this.listObj);
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          this.listObj[objKeyArr[i]].url = response.data;
          this.listObj[objKeyArr[i]].hasSuccess = true;
          return;
        }
      }
    },
    handleRemove(file) {
      const uid = file.uid;
      const objKeyArr = Object.keys(this.listObj);
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          delete this.listObj[objKeyArr[i]];
          return;
        }
      }
    },
    async beforeUpload(file) {
      const _self = this;
      const _URL = window.URL || window.webkitURL;
      const fileName = file.uid;
      if (file.size >= 1024 * 1024) {
        this.$message('请您上传1MB以内的图片');
        return false;
      }
      //图片尺寸拦截
      if (this.limitImgSize.length > 0) {
        try {
          await this.isLimitImgSize(file, this.limitImgSize);
        } catch (error) {
          _self.$message(error);
          return false;
        }
      }
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = function() {
          _self.listObj[fileName] = {
            hasSuccess: false,
            uid: file.uid,
            width: this.width,
            height: this.height
          };
          resolve(true);
        };
        img.onerror = function() {
          delete _self.listObj[fileName];
          _self.$message('请您上传图片类型');
          reject('请上传图片类型');
        };
      });
    },
    /**
     *
     * @param blob
     * @param size //限制图片尺寸大小
     */
    isLimitImgSize(blob, size) {
      return new Promise((resolve, reject) => {
        let restrictRatio = 2 / 3;
        let restrictWidth = size[0];
        let restrictHight = size[1];
        var img = new Image();
        var url = URL.createObjectURL(blob);
        img.src = url;
        img.onload = () => {
          let imgRatio = img.width / img.height;
          if (imgRatio !== restrictRatio) {
            if (img.width <= restrictWidth) {
              if (img.height <= restrictHight) {
                resolve();
              } else {
                reject(`请上传${size[0]}*${size[1]}尺寸内的图片！`);
              }
            } else {
              //上传的图片宽高同时缩小
              let lessenWidthRatio = img.width / restrictWidth;
              let lessenHightSize = img.height / lessenWidthRatio;
              if (lessenHightSize <= restrictHight) {
                resolve();
              } else {
                reject(`请上传${size[0]}*${size[1]}尺寸内的图片！`);
              }
            }
          } else {
            resolve();
          }
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.editor-slide-upload {
  margin-bottom: 20px;
  /deep/ .el-upload--picture-card {
    width: 100%;
  }
}
</style>
